import {
  FLAT_RATE,
  PERCENT_OF_RENT,
  RATE_PER_SPACE_SIZE_UNIT,
  RATE_PER_SPACE_SIZE_UNIT_PER_MONTH,
  RATE_PER_SPACE_SIZE_UNIT_PER_YEAR
} from 'components/lease_structure/form/commission_modes';

export const leaseRateUnitOptions = (leaseStructure) => {
  return [
    { label: getLeaseRateSpaceSizeUnitsLabel(leaseStructure, 'Year'), value: 'per_space_size_unit_per_year' },
    { label: 'Annual Rent', value: 'per_year' },
    { label: getLeaseRateSpaceSizeUnitsLabel(leaseStructure, 'Month'), value: 'per_space_size_unit_per_month' },
    { label: 'Monthly Rent', value: 'per_month' },
  ];
};

export const commissionUnitOptions = (leaseStructure) => {
  return [
    { label: '% of Rent', value: PERCENT_OF_RENT },
    {
      label: getCommissionPerSpaceSizeUnitsLabel(leaseStructure),
      value: RATE_PER_SPACE_SIZE_UNIT
    },
    {
      label: getCommissionPerSpaceSizeUnitsLabel(leaseStructure, 'Month'),
      value: RATE_PER_SPACE_SIZE_UNIT_PER_MONTH
    },
    {
      label: getCommissionPerSpaceSizeUnitsLabel(leaseStructure, 'Year'),
      value: RATE_PER_SPACE_SIZE_UNIT_PER_YEAR
    },
    { label: 'Flat Rate', value: FLAT_RATE },
  ];
};

export const spaceSizeUnitOptions = () => {
  return [
    { label: 'SF', value: 'sf' },
    { label: 'Acres', value: 'acres' }
  ];
};

const getLeaseRateSpaceSizeUnitsLabel = (leaseStructure, suffix) => {
  const squareFootLabel = '$/SF';
  const acreLabel = '$/Acre';

  const prefix = leaseStructure.spaceSizeUnits === 'sf' ? squareFootLabel : acreLabel;

  return `${prefix}/${suffix}`;
};

const getCommissionPerSpaceSizeUnitsLabel = (leaseStructure, suffix) => {
  const squareFootLabel = '$/SF';
  const acreLabel = '$/Acre';

  const prefix = leaseStructure.spaceSizeUnits === 'sf' ? squareFootLabel : acreLabel;

  if (suffix) {
    return `${prefix}/${suffix}`;
  }

  return `${prefix} (Flat Fee)`;
};

export const leaseRateUnitsLabel = (leaseStructure) => {
  if (leaseStructure.leaseRateUnits === 'per_month' || leaseStructure.leaseRateUnits === 'per_year') {
    return null;
  }

  let label;

  if (leaseStructure.leaseRateUnits === 'per_space_size_unit_per_month') {
    label = getLeaseRateSpaceSizeUnitsLabel(leaseStructure, 'Month');
  } else {
    label = getLeaseRateSpaceSizeUnitsLabel(leaseStructure, 'Year');
  }

  return `(${label})`;
};

export const commissionUnitsLabel = (leaseStructure) => {
  let label;

  switch (leaseStructure.commissionMode) {
  case FLAT_RATE:
    return null;
  case PERCENT_OF_RENT:
    return null;
  case RATE_PER_SPACE_SIZE_UNIT:
    return null;
  case RATE_PER_SPACE_SIZE_UNIT_PER_MONTH:
    label = getCommissionPerSpaceSizeUnitsLabel(leaseStructure, 'Month');
    break;
  case RATE_PER_SPACE_SIZE_UNIT_PER_YEAR:
    label = getCommissionPerSpaceSizeUnitsLabel(leaseStructure, 'Year');
  }

  return `(${label})`;
};
